import React from 'react';
import SidebarComponent from './SidebarComponent';
import PageHeader from './PageHeader';

const WastewaterTreatmentSolutions: React.FC = () => {
  return (
    <>
      <PageHeader title="Wastewater Treatment Solutions" />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/commercial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/about-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Wastewater Treatment Solutions</h1>
              <p>We design and implement advanced wastewater treatment solutions tailored to the unique needs of industries and municipalities. Our expertise spans across sewage treatment, effluent treatment, and water recycling systems that support zero liquid discharge (ZLD) goals.</p>

              <h3 className="mb-4">Technologies Offered:</h3>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>ASP, MBBR, SBR, MBR systems</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Tertiary treatment and filtration</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Sludge handling and dewatering</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Treated water reuse systems</p>

              <h3 className="mb-4">Compliance:</h3>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>CPCB and local PCB norms</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Real-time monitoring provisions</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Customized design for site-specific loads</p>
            </div>

            <div className="col-lg-4">
              <SidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default WastewaterTreatmentSolutions;
